import { Card, Group, SimpleGrid, Stack, Text, ThemeIcon } from '@mantine/core'
import { IconTrendingUp } from '@tabler/icons-react'

interface ReturnData {
  period: string
  returnPercentage: number | null
  startDate?: string
  endDate?: string
}

interface Props {
  returns: ReturnData[]
  loading?: boolean
}

export const ReturnsSection: React.FC<Props> = ({ returns }) => {
  const getReturnColor = (returnPercentage: number | null) => {
    if (returnPercentage === null) return 'dimmed'
    return returnPercentage >= 0 ? 'green' : 'red'
  }

  const formatReturn = (returnPercentage: number | null) => {
    if (returnPercentage === null) return '-'
    const prefix = returnPercentage >= 0 ? '+' : ''
    return `${prefix}${returnPercentage.toFixed(2)}%`
  }

  return (
    <Card withBorder>
      <Stack gap="md">
        <Group gap="sm">
          <ThemeIcon color="blue" variant="light" size="lg" radius="md">
            <IconTrendingUp size={20} />
          </ThemeIcon>
          <Text fw={600} size="md">
            Returns
          </Text>
        </Group>

        <Text size="sm" c="dimmed">
          Total returns, excluding dividends
        </Text>

        <SimpleGrid cols={{ base: 1, sm: 2, md: 3, lg: 5 }} spacing="md">
          {returns.map((returnData) => (
            <div key={returnData.period}>
              <Text size="sm" c="dimmed" mb={4}>
                {returnData.period}
              </Text>
              <Text
                fw={600}
                size="lg"
                c={getReturnColor(returnData.returnPercentage)}
              >
                {formatReturn(returnData.returnPercentage)}
              </Text>
              {returnData.startDate && returnData.endDate && (
                <Text size="xs" c="dimmed" mt={2}>
                  {returnData.startDate} - {returnData.endDate}
                </Text>
              )}
            </div>
          ))}
        </SimpleGrid>
      </Stack>
    </Card>
  )
}
